import type { Feature } from 'geojson'
import { simplifyDrawPolygonFeature } from './polygonGeometry'
import { toStorableDrawFeature } from './terraDrawMode'

export function normalizeRestoredDrawFeature(feature: Feature | null) {
  if (!feature) return null

  return simplifyDrawPolygonFeature(toStorableDrawFeature(feature) ?? feature)
}
